import { memoizedGetDateTimeFormat } from './formatDate.mjs';

function getIanaTimeZone(locale, options) {
  return memoizedGetDateTimeFormat(locale, options).resolvedOptions().timeZone;
}

export { getIanaTimeZone };
